import React, { useState } from "react";
import { Mail, Loader2, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { TextField, AreaField, SelectField } from "@/components/forms/Field";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const REASONS = ["New Financing", "Existing Application", "EMD Funding", "Transactional Funding", "Partnership", "Document Question", "General Question"];

export default function Contact() {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (n, v) => setF((s) => ({ ...s, [n]: v }));

  const submit = async () => {
    if (!f.name || !f.email) { toast.error("Name and email are required"); return; }
    setBusy(true);
    try {
      await api.post("/contact", { name: f.name, email: f.email, phone: f.phone || "", company: f.company || "", state: f.state || "", reason: f.reason || "", message: f.message || "" });
      setDone(true);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16">
      <div className="eyebrow mb-3">Contact</div>
      <h1 className="h-display text-4xl sm:text-5xl text-white">Let's talk about your deal.</h1>
      <p className="mt-3 text-dim">Reach out and a BullsEye Capital representative will get back to you.</p>

      {done ? (
        <div className="mt-10 card-surface rounded-2xl p-10 text-center" data-testid="contact-success">
          <CheckCircle2 className="w-12 h-12 text-ok mx-auto" />
          <h3 className="h-display text-2xl text-white mt-4">Message Sent</h3>
          <p className="mt-2 text-dim">Thanks for reaching out. We'll be in touch shortly.</p>
        </div>
      ) : (
        <div className="mt-10 card-surface rounded-2xl p-7 sm:p-8" data-testid="contact-form">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            <TextField label="Name" name="name" value={f.name} onChange={set} required testId="contact-name" />
            <TextField label="Email" name="email" type="email" value={f.email} onChange={set} required testId="contact-email" />
            <TextField label="Phone" name="phone" value={f.phone} onChange={set} testId="contact-phone" />
            <TextField label="Company" name="company" value={f.company} onChange={set} testId="contact-company" />
            <TextField label="State" name="state" value={f.state} onChange={set} testId="contact-state" />
            <SelectField label="Reason for Contact" name="reason" value={f.reason} onChange={set} options={REASONS} testId="contact-reason" />
            <AreaField label="Message" name="message" value={f.message} onChange={set} testId="contact-message" />
          </div>
          <Button onClick={submit} disabled={busy} className="btn-gold rounded-full h-13 px-8 mt-6 h-14 gap-2" data-testid="contact-submit">
            {busy ? <><Loader2 className="w-5 h-5 animate-spin" /> Sending…</> : <><Mail className="w-5 h-5" /> Send Message</>}
          </Button>
        </div>
      )}
    </div>
  );
}
